(function () {
  'use strict';

  var IN_TO_CM = 2.54;
  var CALIBRATION_KEY = 'sthetix-screen-ppi'; // reserved for a future "actual size" calibration flow

  function toNumber(raw) {
    var n = parseFloat(raw);
    return isNaN(n) ? null : n;
  }

  function formatUnitValue(n, unit) {
    var rounded = Math.round(n * 100) / 100;
    return (Number.isInteger(rounded) ? rounded : rounded.toFixed(2).replace(/0+$/, '').replace(/\.$/, '')) + (unit === 'cm' ? ' cm' : '"');
  }

  function convert(value, fromUnit, toUnit) {
    if (fromUnit === toUnit) return value;
    return fromUnit === 'in' ? value * IN_TO_CM : value / IN_TO_CM;
  }

  function getScreenCalibration() {
    // If a future calibration flow stores a pixels-per-inch value, the ruler
    // can switch from an approximate "visual" scale to a screen-calibrated one.
    var ppi = toNumber(localStorage.getItem(CALIBRATION_KEY));
    return ppi && ppi > 0 ? ppi : null;
  }

  function svgEl(tag, attrs) {
    var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
    for (var key in attrs) {
      el.setAttribute(key, attrs[key]);
    }
    return el;
  }

  function initDimensionsBlock(block) {
    var width = toNumber(block.dataset.width);
    var height = toNumber(block.dataset.height);
    var depth = toNumber(block.dataset.depth);
    var storedUnit = block.dataset.unit === 'cm' ? 'cm' : 'in';
    var accentColor = block.dataset.accentColor || '#232323';

    var overlayBtn = block.querySelector('[data-dimensions-toggle="overlay"]');
    var rulerBtn = block.querySelector('[data-dimensions-toggle="ruler"]');
    var rulerPanel = block.querySelector('[data-dimensions-ruler-panel]');
    var rulerTrack = block.querySelector('[data-dimensions-ruler-track]');
    var infoBtn = block.querySelector('[data-dimensions-info]');
    var calibrationNote = block.querySelector('[data-dimensions-calibration-note]');
    var unitButtons = block.querySelectorAll('[data-dimensions-unit]');

    var imageContainer = document.querySelector('[data-dimensions-target]');

    var overlay = null;
    var overlayVisible = false;
    var rulerVisible = false;
    var displayUnit = storedUnit;
    var lastContainerWidth = 0;

    function buildOverlay() {
      if (!imageContainer || overlay) return;

      var computedStyle = window.getComputedStyle(imageContainer);
      if (computedStyle.position === 'static') {
        imageContainer.style.position = 'relative';
      }

      var wrap = document.createElement('div');
      wrap.className = 'sthetix-dimensions-overlay';
      wrap.id = block.dataset.overlayId || '';
      wrap.style.color = accentColor;
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', 'Dimension overlay');

      var svg = svgEl('svg', {
        viewBox: '0 0 100 100',
        preserveAspectRatio: 'none',
        'aria-hidden': 'true'
      });

      function line(x1, y1, x2, y2) {
        return svgEl('line', {
          x1: x1, y1: y1, x2: x2, y2: y2,
          class: 'sthetix-ruler-baseline',
          'vector-effect': 'non-scaling-stroke'
        });
      }

      var labels = [];
      var tickLabels = [];

      // Adds a small perpendicular tick + number at every whole inch/cm along
      // a measurement line, so the scale is readable, not just the total.
      function addTicks(orientation, value) {
        var whole = Math.floor(value + 0.0001);
        for (var i = 1; i <= whole; i++) {
          var fraction = i / value;
          if (orientation === 'v') {
            var y = 91 - fraction * 82;
            if (y < 10.5) continue;
            svg.appendChild(svgEl('line', {
              x1: 4, y1: y, x2: 8, y2: y,
              class: 'sthetix-ruler-tick',
              'vector-effect': 'non-scaling-stroke'
            }));
            tickLabels.push({ x: 2, y: y, text: String(i) });
          } else {
            var x = 9 + fraction * 82;
            if (x > 89.5) continue;
            svg.appendChild(svgEl('line', {
              x1: x, y1: 92, x2: x, y2: 96,
              class: 'sthetix-ruler-tick',
              'vector-effect': 'non-scaling-stroke'
            }));
            tickLabels.push({ x: x, y: 98.5, text: String(i) });
          }
        }
      }

      if (height != null) {
        svg.appendChild(line(6, 9, 6, 91));
        svg.appendChild(line(3, 9, 9, 9));
        svg.appendChild(line(3, 91, 9, 91));
        addTicks('v', height);
        labels.push({ x: 10, y: 50, text: 'Height ' + formatUnitValue(height, storedUnit) });
      }

      if (width != null) {
        svg.appendChild(line(9, 94, 91, 94));
        svg.appendChild(line(9, 91, 9, 97));
        svg.appendChild(line(91, 91, 91, 97));
        addTicks('h', width);
        labels.push({ x: 50, y: 88, text: 'Width ' + formatUnitValue(width, storedUnit) });
      }

      wrap.appendChild(svg);

      tickLabels.forEach(function (l) {
        var tick = document.createElement('span');
        tick.className = 'sthetix-dimensions-overlay__tick-label';
        tick.style.left = l.x + '%';
        tick.style.top = l.y + '%';
        tick.textContent = l.text;
        wrap.appendChild(tick);
      });

      labels.forEach(function (l) {
        var chip = document.createElement('div');
        chip.className = 'sthetix-dimensions-overlay__label';
        chip.style.left = l.x + '%';
        chip.style.top = l.y + '%';
        chip.textContent = l.text;
        wrap.appendChild(chip);
      });

      if (depth != null) {
        var depthChip = document.createElement('div');
        depthChip.className = 'sthetix-dimensions-overlay__label';
        depthChip.style.left = '86%';
        depthChip.style.top = '80%';
        depthChip.textContent = 'Depth ' + formatUnitValue(depth, storedUnit);
        wrap.appendChild(depthChip);
      }

      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'sthetix-dimensions-overlay__close';
      closeBtn.setAttribute('aria-label', 'Hide dimension overlay');
      closeBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        setOverlayVisible(false);
      });
      wrap.appendChild(closeBtn);

      imageContainer.appendChild(wrap);
      overlay = wrap;
    }

    function setOverlayVisible(visible) {
      if (visible) buildOverlay();
      if (!overlay) return;
      overlayVisible = visible;
      overlay.classList.toggle('is-visible', visible);
      if (overlayBtn) overlayBtn.setAttribute('aria-pressed', String(visible));
    }

    function drawRuler() {
      if (!rulerTrack || !imageContainer || width == null) return;

      var containerWidth = imageContainer.clientWidth;
      if (!containerWidth) return;
      lastContainerWidth = containerWidth;

      var calibrationPpi = getScreenCalibration();
      var widthInDisplayUnit = convert(width, storedUnit, displayUnit);
      var pxPerUnit;
      var calibrated = false;

      if (calibrationPpi) {
        pxPerUnit = displayUnit === 'in' ? calibrationPpi : calibrationPpi / IN_TO_CM;
        calibrated = true;
      } else {
        pxPerUnit = containerWidth / widthInDisplayUnit;
      }

      var totalUnits = Math.max(1, Math.ceil(widthInDisplayUnit));
      var totalPx = totalUnits * pxPerUnit;

      rulerTrack.innerHTML = '';
      var svg = svgEl('svg', {
        width: totalPx,
        height: 34,
        viewBox: '0 0 ' + totalPx + ' 34',
        style: 'color:' + accentColor
      });

      svg.appendChild(svgEl('line', {
        x1: 0, y1: 26, x2: totalPx, y2: 26,
        class: 'sthetix-ruler-baseline'
      }));

      for (var i = 0; i <= totalUnits; i++) {
        var x = i * pxPerUnit;
        svg.appendChild(svgEl('line', {
          x1: x, y1: 12, x2: x, y2: 26,
          class: 'sthetix-ruler-tick sthetix-ruler-tick--major'
        }));

        var label = svgEl('text', { x: x, y: 10, class: 'sthetix-ruler-label', 'text-anchor': i === 0 ? 'start' : (i === totalUnits ? 'end' : 'middle') });
        label.textContent = i + (displayUnit === 'cm' ? '' : '"');
        svg.appendChild(label);

        if (i < totalUnits && pxPerUnit > 26) {
          svg.appendChild(svgEl('line', {
            x1: x + pxPerUnit / 2, y1: 18, x2: x + pxPerUnit / 2, y2: 26,
            class: 'sthetix-ruler-tick'
          }));
        }
      }

      rulerTrack.appendChild(svg);

      if (calibrationNote) {
        calibrationNote.hidden = calibrated;
      }
    }

    function setRulerVisible(visible) {
      rulerVisible = visible;
      if (!rulerPanel) return;
      rulerPanel.hidden = !visible;
      if (rulerBtn) rulerBtn.setAttribute('aria-pressed', String(visible));
      if (visible) drawRuler();
    }

    if (overlayBtn) {
      overlayBtn.addEventListener('click', function () {
        setOverlayVisible(!overlayVisible);
      });
    }

    if (rulerBtn) {
      rulerBtn.addEventListener('click', function () {
        setRulerVisible(!rulerVisible);
      });
    }

    if (infoBtn && calibrationNote) {
      infoBtn.addEventListener('click', function () {
        var expanded = !calibrationNote.hidden;
        calibrationNote.hidden = expanded;
        infoBtn.setAttribute('aria-expanded', String(!expanded));
      });
    }

    unitButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var unit = btn.dataset.dimensionsUnit;
        if (unit === displayUnit) return;
        displayUnit = unit;
        unitButtons.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', String(active));
        });
        if (rulerVisible) drawRuler();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (overlayVisible) setOverlayVisible(false);
      if (rulerVisible) setRulerVisible(false);
    });

    if (imageContainer && width != null && window.ResizeObserver) {
      var observer = new ResizeObserver(function (entries) {
        var newWidth = entries[0].contentRect.width;
        if (Math.abs(newWidth - lastContainerWidth) < 1) return;
        lastContainerWidth = newWidth;
        if (rulerVisible) drawRuler();
      });
      observer.observe(imageContainer);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-dimensions-block]').forEach(initDimensionsBlock);
  });
})();
